import { pageHead } from "@/lib/route-head";
import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const LearnMore = lazy(() => import("@/pages/LearnMore"));

export const Route = createFileRoute("/_public/learn-more")({
  head: () => pageHead({ path: "/learn-more", title: "Learn More — How Amorette Works", description: "Discover how Amorette curates small, verified dinners and social experiences that bring people together in person." }),
  component: LearnMore,
});
